module.exports = __webpack_public_path__ + "static/img/record-bg.0873440d.png";